import SizeTable from './SizeTable';
export default SizeTable;
